import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { createInitialStatePart, setReducerState } from '../utils/reduxUtils';
import { CertificatesInitialState } from '../models/certificates';
import { LoadCertificatesListAction, UploadCSRAction, RevokeCSRAction } from '../actionTypes/certificates';
import { ICertificate } from '../models/certificates';
import { FailedResponse } from '../models/common';
import { RootState } from '../store';

const STATE_KEY = 'certificates';
const initialState = {
  ...createInitialStatePart('certificatesList', []),
  activeModal: {},
};

const certificates = createSlice({
  name: STATE_KEY,
  initialState: initialState as CertificatesInitialState,
  reducers: {
    loadCertificates: (state, action: PayloadAction<LoadCertificatesListAction>) => {
      return setReducerState('loading', 'certificatesList', { state, action });
    },
    loadCertificatesSuccess: (state, { payload }: PayloadAction<ICertificate[]>) => {
      const data = payload.sort((a, b) => b.creationDate.localeCompare(a.creationDate));
      return setReducerState('loaded', 'certificatesList', { state, data });
    },
    loadCertificatesFail: (state, action: PayloadAction<FailedResponse>) => {
      return setReducerState('error', 'certificatesList', { state, error: action.payload });
    },
    uploadCSR: (state, action: PayloadAction<UploadCSRAction>) => {
      return setReducerState('loading', 'certificatesList', { state, action });
    },
    uploadCSRSuccess: (state, { payload }: PayloadAction<ICertificate>) => {
      const data = [...state.certificatesList];
      data.unshift(payload);
      return setReducerState('loaded', 'certificatesList', { state, data });
    },
    uploadCSRFail: (state, action: PayloadAction<FailedResponse>) => {
      return setReducerState('error', 'certificatesList', { state, error: action.payload });
    },
    revokeCSR: (state, action: PayloadAction<RevokeCSRAction>) => {
      return setReducerState('loading', 'certificatesList', { state, action });
    },
    revokeCSRSuccess: (state, { payload }: PayloadAction<{ id: number }>) => {
      const data = [...state.certificatesList];
      const list = data.filter((c) => c.id !== payload.id);
      return setReducerState('loaded', 'certificatesList', { state, data: list });
    },
    revokeCSRFail: (state, action: PayloadAction<FailedResponse>) => {
      return setReducerState('error', 'certificatesList', { state, error: action.payload });
    },
    setActiveModalDetails: (state, { payload }: PayloadAction<any>) => {
      return { ...state, activeModal: payload };
    },
  },
});

//Actions
export const certificatesActions = certificates.actions;

//Selectors
export const certificatesList = (state: RootState) => state.certificates.certificatesList;
export const modalState = (state: RootState) => state.certificates.activeModal;

//Reducers
export default certificates.reducer;
